<template>
  <div class="manage-requests-item">
    <div class="manage-requests-item-child">
      <child-avatar class="manage-requests-item-child-avatar"
                    :child="child"
                    size="normal" />

      <div class="manage-requests-item-child-info">
        <div class="title">
          {{ title }}
        </div>

        <a :href="request.param"
           class="one-liner request-link"
           target="_blank">
          {{ urlTitle }}
        </a>

        <div class="comment">
          {{ request.reason }}
        </div>
      </div>
    </div>

    <div v-if="isToday(request.last_update)" class="manage-requests-item-time">
      {{ request.last_update | timeAgo }}
    </div>

    <div class="manage-requests-item-time">
      {{ request.last_update | localTime }}
    </div>

    <div class="manage-requests-item-btn-group">
      <div class="ignore" @click="ignore">
        {{ $t("childRequests.ignore") }}
      </div>

      <base-button  :rounded="false"
                    :loading="loading"
                    color="success"
                    @click="grant">
        {{ buttonText }}
      </base-button>
    </div>
  </div>
</template>

<script>
  import ChildAvatar from '@/components/Child/ChildAvatar'
  import { isToday } from '@/services/intl'
  import { getDomain } from '@/services/utils.js'

  export default {
    components: {
      ChildAvatar
    },

    props: {
      request: {
        type: Object,
        required: true
      }
    },

    data() {
      return {
        loading: false
      }
    },

    computed: {
      ...mapGetters('children', {
        getChildById: 'getById',
      }),

      ...mapGetters('auth', {
        currentUser: 'currentUser'
      }),

      groupId() {
        return this.currentUser.group_id
      },

      child() {
        return this.getChildById(this.request.user_id)
      },

      title() {
        return `${this.child.name} ${this.$t("childRequests.hasRequestedAccessTo")}`
      },

      buttonText() {
        return this.$t("childRequests.addToWhitelist")
      },

      urlTitle() {
        return getDomain(this.request.param)
      }
    },

    methods: {
      isToday,

      ignore() {
        this.showModal('requestAction', {
          request: this.request,
          action: 'ignore'
        })
      },

      grant() {
        this.showModal('requestAction', {
          request: this.request,
          action: 'grant'
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .manage-requests-item {
    width: 100%;
    cursor: default;

    display: flex;
    align-items: center;
    justify-content: space-between;

    padding: 18px 0;
    border-bottom: 1px solid #f2f2f2;

    &-child {
      display: flex;

      width: 50%;
      max-width: 50%;

      &-avatar {
        margin-right: 8px;
      }

      &-info {
        display: flex;
        flex-direction: column;
        padding: 4px 0;
        color: #3E3A3B;

        .title {
          color: #3E3A3B;
          font-size: 18px;
          line-height: 21px;

          margin-bottom: 4px;
        }

        .request-link {
          color: map.get($colors, primary);
          font-size: 14px;
          line-height: 17px;

          &:hover {
            cursor: pointer;
          }
        }

        .comment {
          font-size: 14px;
          line-height: 17px;
          opacity: .5;

          margin-top: 4px;

          word-break: break-all;
        }
      }
    }

    &-time {
      font-size: 16px;
      line-height: 19px;

      color: #3E3A3B;
      opacity: .5;
    }

    &-btn-group {
      display: flex;
      align-items: center;

      font-size: 16px;
      line-height: 19px;

      .ignore {
        width: auto;
        display: flex;
        align-items: center;
        cursor: pointer;

        color: #3E3A3B;
        opacity: .5;
        margin-right: 32px;

        &:hover {
          opacity: 1;
        }
      }
    }
  }

  @media (max-width: 5120px) {
    .manage-requests-item {
      &-child {
        &-info {
          width: 1000px;
        }
      }
    }
  }

  @media (max-width: 2560px) {
    .manage-requests-item {
      &-child {
        &-info {
          width: 800px;
        }
      }
    }
  }

  @media (max-width: 1920px) {
    .manage-requests-item {
      &-child {
        &-info {
          width: 650px;
        }
      }
    }
  }

  @media (max-width: 1680px) {
    .manage-requests-item {
      &-child {
        &-info {
          width: 500px;
        }
      }
    }
  }

  @media (max-width: 1440px) {
    .manage-requests-item {
      &-child {
        &-info {
          width: 360px;
        }
      }

      &-btn-group {
        display: block;

        .ignore {
          width: 50px;
          margin: 0 auto 12px;
          justify-content: center;
        }
      }
    }
  }

  @media (max-width: 1280px) {
    .manage-requests-item {
      &-child {
        &-info {
          width: 300px;
        }
      }
    }
  }

  @media (max-width: 1024px) {
    .manage-requests-item {
      &-child {
        &-info {
          width: 180px;
        }
      }
    }
  }
</style>